/* eslint-disable react/prop-types */
import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';

import { BarcodeOutlined } from '@ant-design/icons';
import {
  Modal,
  Card,
  Col,
  Row,
  Spin,
  message,
} from 'antd';
import {
  Title, Button, Text,
} from 'components';

import generateReferenceBank from 'api/referenciasDeBanco';
import { printReferenceOrder } from 'api/recaudacion';
import Previewer from 'components/Previewer';
import _logger from 'utils/logger';
import { Container } from 'components/Steps';

/* eslint-disable import/no-dynamic-require */
const ENV_NAME = process.env.REACT_APP_ENV_NAME;

const bancos = [
  {
    id: 4,
    name: 'Otros bancos',
    banco: 'otros',
    referencia: generateReferenceBank,
    instrucciones: 'AQUI LAS INSTRCCIONES',
    descripcion: 'BANCO SANTANDER',
    title: 'Exclusivo Otros Bancos',
  },
];

// Components
const CustomCard = ({
  name,
  banco,
  urlBanco,
  descripcion,
  title,
  showDialog,
  selectedBanco,
}) => {
  // eslint-disable-next-line global-require
  const logo = require(`../../../../public/${ENV_NAME}/bancos/${banco}.png`).default;
  return (
    <Col key={name} span={8} style={{ display: 'flex', justifyContent: 'center' }}>
      <Card
        key={name}
        hoverable
        onClick={() => {
          if (banco === 'bbva') {
            showDialog({
              name,
              banco,
              urlBanco,
              descripcion,
            });
            return;
          }
          selectedBanco(banco, urlBanco, descripcion);
        }}
        style={{
          width: 250,
          margin: 10,
          height: 190,
          display: 'flex',
          justifyContent: 'center',
          boxShadow: '2px 4px 8px 2px rgba(0,0,0,0.4)',
          borderRadius: 8,
        }}
      >
        <Container style={{ padding: 0 }}>
          <Text style={{
            fontWeight: '600',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            fontSize: 16,
            textAlign: 'center',
          }}
          >
            { title }
          </Text>
          <img
            alt={`banco-${name}`}
            src={logo}
            style={{
              width: '190px',
              padding: 20,
              marginTop: 20,
            }}
          />
        </Container>
      </Card>
    </Col>
  );
};

const ModalBancos = ({
  visible,
  onCancel,
  cargosGenerados,
  padron,
  tipoDePadron,
  padrones,
  currentClassifier,
  cbReferenciaBanco,
  isNewFolio,
  totalProp,
  periodoFiscal,
  folio,
}) => {
  const formRef = useRef();
  const [url, setUrl] = useState();
  const [visiblePreview, setVisiblePreview] = useState(false);
  const [previewBase64, setPreviewBase64] = useState();
  const [visibleInstrucciones, setVisibleInstrucciones] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (url) {
      setTimeout(() => {
        formRef.current.submit();
      }, 500);
    }
  }, [url]);

  // Functions
  const showOrder = async () => {
    try {
      setLoading(true);
      if (isNewFolio) {
        const request = await cbReferenciaBanco();
        if (request) {
          const values = {
            folio: request.folio_banco,
            entidad: 1,
            referencia_normal: false,
            base64: request.data,
          };
          const order = await printReferenceOrder(values);
          if (order) {
            setPreviewBase64(values.base64 || order?.data);
            setVisiblePreview(true);
          }
        }
      } else {
        setVisiblePreview(true);
      }
    } catch (error) {
      _logger(error);
    } finally {
      setLoading(false);
    }
  };

  const selectedBanco = async (banco, urlBanco, descripcion) => {
    try {
      setLoading(true);
      if (banco === 'otros') {
        setVisibleInstrucciones(true);
        return;
      }
      const result = await urlBanco[banco](
        tipoDePadron,
        padron,
        cargosGenerados,
        padrones,
        currentClassifier,
        descripcion,
        totalProp,
        periodoFiscal,
        folio,
      );
      if (!result) {
        setLoading(false);
        message.warn('intentalo de nuevo');
        return;
      }
      if (result) {
        setUrl(result);
      }
    } catch (error) {
      _logger(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Modal
        style={{ top: 20 }}
        width={1200}
        visible={visible}
        onCancel={() => onCancel()}
        footer={null}
        centered
      >
        <Spin spinning={loading} tip="Cargando...">
          <Row gutter={[10, 15]} justify="center">
            <Title level={4} $accent $bold>
              SERVICIO DE PAGO EN LINEA
            </Title>
            <Col span={24} style={{ marginTop: 30 }}>
              <Row gutter={[10, 10]} justify="center">
                {bancos.map((banco) => (
                  <CustomCard
                    key={banco.name}
                    name={banco.name}
                    banco={banco.banco}
                    urlBanco={banco.referencia}
                    descripcion={banco.descripcion}
                    title={banco.title}
                    selectedBanco={selectedBanco}
                  />
                ))}
              </Row>
            </Col>
          </Row>
        </Spin>
      </Modal>
      <Modal
        visible={visibleInstrucciones}
        footer={null}
        onCancel={() => setVisibleInstrucciones(false)}
        width={700}
        centered
        bodyStyle={{ padding: 0 }}
        cancelButtonProps={{
          style: {
            color: '#fff',
          },
        }}
      >
        <Spin spinning={loading} tip="Cargando...">
          <div style={{ overflow: 'hidden', background: '#fff' }}>
            <div style={{ background: '#681B2D', padding: '24px 0', textAlign: 'center' }}>
              <Title level={4} $accent $bold color="#fff">
                Instrucciones para Transferencia Interbancaria
              </Title>
            </div>
            <Row gutter={0} style={{ margin: 0 }}>
              <Col xs={24} md={14} style={{ padding: '32px 24px 24px 24px', background: '#fff' }}>
                <Text>
                  Realiza tu transferencia interbancaria con los siguientes datos.
                </Text>
                <br />
                <div style={{ fontSize: 15, marginBottom: 10 }}>
                  <b>Beneficiario:</b>
                  {' '}
                </div>
                <div style={{ fontSize: 15, marginBottom: 10 }}>
                  <b>Banco destino:</b>
                  {' '}
                  BANORTE
                </div>
                <div style={{ fontSize: 15, marginBottom: 10 }}>
                  <b>CLABE:</b>
                  {' '}
                </div>
                <ol style={{
                  paddingLeft: 18,
                  fontSize: 16,
                  color: '#333',
                  marginBottom: 18,
                }}
                >
                  <li style={{ marginBottom: 10 }}>
                    Genere su transferencia de pago correspondiente, la cual puedes generar
                    desde el botón de ubicado en la parte inferior con el texto
                    &quot;Generar orden de transferencia interbancaria&quot;
                  </li>
                  <li style={{ marginBottom: 10 }}>
                    Una vez generado el formato correspondiente, ingresa a tu banca en línea.
                  </li>
                  <li style={{ marginBottom: 10 }}>
                    Por primera vez, realice el alta del beneficiario, de lo contrario, agregue
                    la cuenta clabe interbancaria correspondiente y proceda al alta.
                  </li>
                  <li style={{ marginBottom: 10 }}>
                    El formato generado contiene una referencia de pago de a 20 digitos la cual
                    se debera colocar en el campo concepto de su banca electrónica al momento de
                    realizar la transferencia.
                  </li>
                </ol>
              </Col>
              <Col
                xs={24}
                md={10}
                style={{
                  background: '#F7F7F7',
                  padding: '32px 18px',
                  borderLeft: '1px solid #eee',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                }}
              >
                <div
                  style={{
                    color: '#681B2D',
                    fontWeight: 'bold',
                    fontSize: 17,
                    marginBottom: 12,
                    textAlign: 'center',
                  }}
                >
                  Información para alta del beneficiario
                </div>
                <div style={{ fontSize: 15, marginBottom: 8 }}>
                  <b>Nombre:</b>
                  <br />
                </div>
                <div style={{ fontSize: 15, marginBottom: 8 }}>
                  <b>RFC:</b>
                  <br />
                </div>
                <div style={{ fontSize: 15, marginBottom: 8 }}>
                  <b>Teléfono:</b>
                  <br />
                </div>
                <div style={{ fontSize: 15 }}>
                  <b>Domicilio:</b>
                  <br />
                </div>
              </Col>
            </Row>
            <div style={{
              padding: 24, background: '#fff', textAlign: 'center', borderTop: '1px solid #eee',
            }}
            >
              <Button
                $accent
                style={{ minWidth: 260, fontSize: 16, height: 44 }}
                onClick={async () => {
                  await showOrder();
                  setVisibleInstrucciones(false);
                }}
              >
                <BarcodeOutlined style={{ marginRight: 8, fontSize: 18 }} />
                Generar orden de transferencia interbancaria
              </Button>
            </div>
          </div>
        </Spin>
      </Modal>
      <Previewer
        visible={visiblePreview}
        base64={previewBase64}
        isPDF
        onCancel={() => setVisiblePreview(false)}
      />
    </>
  );
};

export default ModalBancos;

ModalBancos.propTypes = {
  visible: PropTypes.bool.isRequired,
  onCancel: PropTypes.func,
  cargosGenerados: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
    nombre: PropTypes.string,
    monto: PropTypes.number,
  })),
  padron: PropTypes.shape({
    id: PropTypes.number,
    nombre: PropTypes.string,
    monto: PropTypes.number,
  }),
  currentClassifier: PropTypes.string,
  tipoDePadron: PropTypes.number,
  padrones: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
    nombre: PropTypes.string,
    monto: PropTypes.number,
  })),
  cbReferenciaBanco: PropTypes.func.isRequired,
  isNewFolio: PropTypes.bool,
  totalProp: PropTypes.string,
  periodoFiscal: PropTypes.string,
  folio: PropTypes.string,
};

ModalBancos.defaultProps = {
  onCancel: null,
  cargosGenerados: [],
  padron: null,
  currentClassifier: '',
  tipoDePadron: null,
  padrones: [],
  isNewFolio: false,
  totalProp: 'adeudo_total',
  periodoFiscal: null,
  folio: null,
};
